import React from 'react';
import PropTypes from 'prop-types';
import FilePreviewer from '../FilePreviewer/FilePreviewer';
import utils from '../../../lib/utils';
import { ownerRequired, expirationRequired } from '../../../lib/stipFileValidation';


export class FilePreviewerAndTagger extends React.Component {
  sendTagName(event) {
    this.props.handleSetTag(event, this.props.file.preview);
  }

  sendDescription(event) {
    this.props.handleSetDescription(event.target.value, this.props.file.preview);
  }

  sendOwner(event) {
    this.props.handleSetOwner(event.target.value, this.props.file.preview);
  }

  sendExpiration(event) {
    this.props.handleSetExpiration(event.target.value, this.props.file.preview);
  }

  // Underwriting requires a description when a stip is tagged "Other", so we
  // only surface the free-text field for that tag.
  renderDescriptionInput() {
    if (this.props.file.tag !== 'Other') {
      return null;
    }
    return (
      <div className="stip-upload-previewer-tagger__description">
        <input
          type="text"
          className="stip-upload-previewer-tagger__description-input"
          placeholder="Please describe this document"
          value={this.props.file.description || ''}
          onChange={this.sendDescription.bind(this)}
        />
      </div>
    );
  }

  // Underwriting requires an expiration date on any Drivers License, so surface
  // the date field for that tag alone.
  renderExpirationInput() {
    if (!expirationRequired(this.props.file)) {
      return null;
    }
    return (
      <div className="stip-upload-previewer-tagger__expiration">
        <label className="stip-upload-previewer-tagger__field-label">
          Expiration date
        </label>
        <input
          type="date"
          className="stip-upload-previewer-tagger__expiration-input"
          value={this.props.file.expires_on || ''}
          onChange={this.sendExpiration.bind(this)}
        />
      </div>
    );
  }

  // Only ask which owner the license belongs to when the submission has more
  // than one. With a single owner there is nothing to disambiguate, and the API
  // fills it in.
  renderOwnerDropdown() {
    const owners = this.props.owners || [];
    if (!ownerRequired(this.props.file, owners.length)) {
      return null;
    }

    const options = owners.map(owner => ({
      value: owner.uuid,
      label: `${owner.first_name || ''} ${owner.last_name || ''}`.trim() || owner.uuid
    }));

    return (
      <div className="stip-upload-previewer-tagger__owner">
        <label className="stip-upload-previewer-tagger__field-label">
          Whose license is this?
        </label>
        {utils.renderSelect(
          utils.mapDropdownOptions(options, "stip-upload-owner-option"),
          "stip-upload-previewer-tagger__owner-dropdown",
          this.sendOwner.bind(this),
          "- Choose Owner -",
          this.props.file.owner_uuid || ''
        )}
      </div>
    );
  }

  renderTagDropdown() {
    const mapOptions = utils.mapDropdownOptions(
      this.props.fileTaggerDropdownOptions,
      "stip-upload-tag-option"
    );
    return(
      utils.renderSelect(
        mapOptions,
        "stip-upload-previewer-tagger__tagger-dropdown",
        this.sendTagName.bind(this),
        "- Choose File Type -",
        this.props.file.tag
      )
    );
  }

  renderTitle() {
    return (
      <div className="stip-upload-previewer-tagger__title">
        <div className="stip-upload-previewer-tagger__filename-wrap">
          <h4 title={this.props.file.name} className="stip-upload-previewer-tagger__filename">
            {`${utils.truncateTitle(this.props.file.name, 48)}`}
          </h4>
        </div>
      </div>
    );
  }

  render() {
    return(
      <div className="stip-upload-previewer-tagger">
        <div className="stip-upload-previewer-tagger__left-column">
          <div className="stip-upload-previewer-tagger__file-previewer">
            <FilePreviewer
              file={this.props.file}
            />
          </div>
        </div>
        <div className="stip-upload-previewer-tagger__right-column">
          {this.renderTitle()}
          <div className="stip-upload-previewer-tagger__tagger">
            {this.renderTagDropdown()}
          </div>
          {this.renderDescriptionInput()}
          {this.renderExpirationInput()}
          {this.renderOwnerDropdown()}
        </div>
      </div>
    );
  }
}

FilePreviewerAndTagger.propTypes = {
  file: PropTypes.object,
  handleSetTag: PropTypes.func,
  handleSetDescription: PropTypes.func,
  handleSetOwner: PropTypes.func,
  handleSetExpiration: PropTypes.func,
  fileTaggerDropdownOptions: PropTypes.array,
  owners: PropTypes.array
};

export default FilePreviewerAndTagger;
